import { Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, InputGroup, InputRightElement, Select, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addNewUser } from '../../store/actions';
import { registerFormTypes } from '../../types';
import { registerFormValidation } from '../../utils';
import { useFormik } from 'formik';

export const AddUser = () => {

    const [showPassword, setShowPassword] = useState(false);
    const { company } = useAppSelector(state => state.companyReducer);

    const dispatch: AppDispatch = useAppDispatch();
    const navigate = useNavigate();

    const addUserForm = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            gender: '',
            password: '',
        },
        validationSchema: registerFormValidation,
        validateOnBlur: true,
        onSubmit: (values: registerFormTypes) => {
            addUserForm.setSubmitting(true);
            const { company_id } = company;
            const newValues = {...values, company_id};
            dispatch(addNewUser(newValues)).then(() => {
                navigate('/users');
                addUserForm.setSubmitting(false);
            })
            .catch(() => {
                addUserForm.setSubmitting(false);
            });
        }
    });

    useEffect(() => {
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/users' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Add new user.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={addUserForm.handleSubmit}>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="firstName" isRequired mb={addUserForm.errors.first_name ? 0 : 5}>
                                        <FormLabel>First name</FormLabel>
                                        <Input name='first_name' type="text" value={addUserForm.values.first_name} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur} />
                                        {addUserForm.errors.first_name && <Text fontSize='sm' color='red.400'>{addUserForm.errors.first_name}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="lastName" isRequired mb={addUserForm.errors.last_name ? 0 : 5}>
                                        <FormLabel>Last name</FormLabel>
                                        <Input name='last_name' type="text" value={addUserForm.values.last_name} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur} />
                                        {addUserForm.errors.last_name && <Text fontSize='sm' color='red.400'>{addUserForm.errors.last_name}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="email" isRequired mb={addUserForm.errors.email ? 0 : 5}>
                                        <FormLabel>Email address</FormLabel>
                                        <Input name='email' type="email" value={addUserForm.values.email} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur} />
                                        {addUserForm.errors.email && <Text fontSize='sm' color='red.400'>{addUserForm.errors.email}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="phone" isRequired mb={addUserForm.errors.phone ? 0 : 5}>
                                        <FormLabel>Phone number</FormLabel>
                                        <Input name='phone' type="tel" value={addUserForm.values.phone} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur} />
                                        {addUserForm.errors.phone && <Text fontSize='sm' color='red.400'>{addUserForm.errors.phone}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="gender" isRequired mb={addUserForm.errors.gender ? 0 : 5}>
                                        <FormLabel>Gender</FormLabel>
                                        <Select name='gender' placeholder='Select gender' value={addUserForm.values.gender} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur}>
                                            <option value='male'>Male</option>
                                            <option value='female'>Female</option>
                                        </Select>
                                        {addUserForm.errors.gender && <Text fontSize='sm' color='red.400'>{addUserForm.errors.gender}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="role" isRequired mb={addUserForm.errors.role ? 0 : 5}>
                                        <FormLabel>Role</FormLabel>
                                        <Select name='role' placeholder='Select role' value={addUserForm.values.role} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur}>
                                            <option value='driver'>Driver</option>
                                            <option value='mechanic'>Mechanic</option>
                                            <option value='admin'>Admin</option>
                                        </Select>
                                        {addUserForm.errors.role && <Text fontSize='sm' color='red.400'>{addUserForm.errors.role}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <FormControl id="password" isRequired mb={addUserForm.errors.password ? 0 : 5}>
                                <FormLabel>Password</FormLabel>
                                <InputGroup>
                                    <Input name='password' type={showPassword ? 'text' : 'password'} value={addUserForm.values.password} onChange={addUserForm.handleChange} onBlur={addUserForm.handleBlur} />
                                    <InputRightElement h={'full'}>
                                        <Button
                                            variant={'ghost'}
                                            onClick={() =>
                                                setShowPassword((showPassword) => !showPassword)
                                            }>
                                            {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                {addUserForm.errors.password && <Text fontSize='sm' color='red.400'>{addUserForm.errors.password}</Text>}
                            </FormControl>
                            <Stack spacing={10} mt={3}>
                                <Button
                                    type='submit'
                                    size="lg"
                                    colorScheme={'yellow'}
                                    isDisabled={addUserForm.isSubmitting || !addUserForm.isValid}
                                    isLoading={addUserForm.isSubmitting}
                                    >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};